<template>
  <div class="">
    <div class="pp" @click="open">
      <img class="pimg" src="@/assets/img/share.png" alt="" />分享
    </div>
    <el-dialog
      append-to-body
      width="600px"
      title="分享给"
      :visible.sync="visible"
      :before-close="reset"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="sd">
        <div class="input">
          <el-input
            clearable
            placeholder="通过员工姓名搜索..."
            v-model="name"
            @input="getTree"
          ></el-input>
        </div>

        <div
          v-for="item in employeeAllArr"
          :key="item.id"
          class="flex item ai"
          @click="share_id = item.id"
        >
          <i class="el-icon-success icon" v-show="share_id == item.id"></i>
          <div class="success" v-show="share_id != item.id"></div>
          <div class="flex ju flex_1 ai il">
            <div class="flex ai">
              <img class="ta" v-if="item.picture" :src="item.picture" alt="" />
              <div v-else class="tan">
                {{ item.name ? item.name.slice(-1) : "" }}
              </div>
              <span>{{ item.name }}</span>
            </div>
            <div>{{ item.title }}</div>
          </div>
        </div>
      </div>
      <template #footer>
        <el-row type="flex" justify="end">
          <el-button @click="reset">取消</el-button>
          <el-button type="primary" @click="submitForm">完成</el-button>
        </el-row>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    dataInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      visible: false,
      employeeAllArr: [],
      share_id: "",
      name: "",
    };
  },

  methods: {
    getTree() {
      this.$http
        .get("/admin/employee/all", {
          params: { status: 1, show_department: 1, name: this.name },
        })
        .then((res) => {
          if (res.code == 1) {
            this.employeeAllArr = res.data.list;
          }
        });
    },
    open() {
      this.visible = true;
      this.getTree();
    },
    reset() {
      this.name = "";
      this.share_id = "";
      this.visible = false;
    },
    submitForm() {
      if (!this.share_id) return this.$message.error("请选择分享员工");
      this.$http
        .post("/admin/employeeApproval/share", {
          id: this.dataInfo.id,
          share_id: this.share_id,
        })
        .then((res) => {
          if (res.code == 1) {
            this.$message.success("分享成功");
          }
        });
      this.reset();
    },
  },
};
</script>
<style lang="scss" scoped>
.pp {
  font-size: 12px;
  color: #646b75;
  cursor: pointer;
  font-weight: 500;
}
.pimg {
  width: 12px;
  height: 12px;
  margin: 0 5px 0 0;
}
.sd {
  width: 562px;
  height: 522px;
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #e5e5e5;
  overflow-y: scroll;
}
.icon {
  color: #0476fc;
  font-size: 24px;
}
.ta {
  width: 32px;
  height: 32px;
  margin: 0 10px 0 0;
  border-radius: 50%;
}
.tan {
  background: #0476fc;
  width: 32px;
  height: 32px;
  margin: 0 10px 0 0;
  border-radius: 50%;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}
.flex {
  display: flex;
}
.ju {
  justify-content: space-between;
}
.item {
  border-bottom: 1px solid #e5e5e5;
  padding: 20px 0;
  margin: 0 20px;
  cursor: pointer;
}
.flex_1 {
  flex: 1;
}
.ai {
  align-items: center;
}
.il {
  margin: 0 0 0 20px;
}
.success {
  width: 23px;
  height: 23px;
  border-radius: 50%;
  border: 1px solid #e5e5e5;
}
.input {
  margin: 0 20px;
  padding: 20px 0 0;
  position: sticky;
  top: 0;
  background: #fff;
}
</style>

